export default __webpack_public_path__ + "static/service-consulting-4-2dd973b4dc1b0503c8b3866514837204.svg";